import {getBlockAbove} from "./getBlockAbove.js";
import {isEnd} from "./isEnd.js";
export const isSelectionAtBlockEnd = (editor) => {
  const path = getBlockAbove(editor)?.[1];
  return !!path && isEnd(editor, editor.selection?.focus, path);
};
